export const firstClosestParkingInfoSelector = ({firstClosestParkingInfo}) => firstClosestParkingInfo